import { useContext, useCallback, useEffect, useMemo } from "react";

import {
  Grid,
  Switch,
  FormControlLabel,
  Checkbox,
  Tooltip,
} from "@material-ui/core";

import TextField from "../../../../components/basics/TextFieldErp";
import Fieldset from "../../../../components/basics/Fieldset";
import Chip from "../../../../components/basics/Chip";
import Card from "../../../../components/cards/Card";
import SelectErp from "../../../../components/basics/SelectErp";
import {
  HeaderAccordion,
  Line,
  CheckItem,
  Form,
} from "../styles/ClassificacaoServico";

import { ClassificacaoServicoContext } from "../contexts/ClassificacaoServicoContext";
import { QueryParamsContext } from "../../../../context/QueryParamsContext";
import { ConfigurationContext } from "../../gerenciamentocontrato/contexts/ConfigurationContext";

import useClassificacaoServicoController from "../controllers/ClassificacaoServicoController";
import { getPerfilTributario } from "../../../../repositories/qerpapi/impostos/ImpostosRepository";

const AccordionClassifPrincipal = ({ utilizaNovaNfse }) => {
  const { queryParams } = useContext(QueryParamsContext);
  const {
    active,
    setActive,
    description,
    setDescription,
    value,
    setValue,
    listServiceType,
    serviceType,
    setServiceType,
    companies,
    errors,
    perfilTributario,
    setPerfilTributario,
    perfilTributarioOptions,
    setPerfilTributarioOptions,
  } = useContext(ClassificacaoServicoContext);

  const { configuration } = useContext(ConfigurationContext);

  const { handleCheckCompany } = useClassificacaoServicoController();

  const loadPerfilTributarioOptions = useCallback(async () => {
    try {
      const perfilTributarioData = await getPerfilTributario();
      setPerfilTributarioOptions(
        (perfilTributarioData || []).filter(
          (item) => item.ativo === true && item.nfse === true
        )
      );
    } catch (error) {
      console.error("Erro ao buscar perfis tributários:", error);
    }
  }, [setPerfilTributarioOptions]);

  useEffect(() => {
    loadPerfilTributarioOptions();
  }, [loadPerfilTributarioOptions]);

  const handlePerfilTributarioChange = useCallback(
    (newValue) => {
      setPerfilTributario(newValue);
    },
    [setPerfilTributario]
  );

  useEffect(() => {
    const resolved =
      perfilTributario?.id != null &&
      perfilTributarioOptions?.find((opt) => opt.id === perfilTributario.id);

    if (resolved && resolved !== perfilTributario) {
      setPerfilTributario(resolved);
    }
  }, [perfilTributarioOptions, perfilTributario, setPerfilTributario]);

  const textTooltip = useMemo(
    () =>
      "As alterações previstas pela Reforma Tributária para este regime só terão efeito a partir de 2027. Até lá, permanecem válidas as regras atuais, sem necessidade de ajustes ou preocupação com os tributos IBS e CBS.",
    []
  );

  const isReformaTributaria = useMemo(
    () => queryParams?.crt === "3",
    [queryParams]
  );

  return (
    <>
      <Fieldset
        titulo={
          <HeaderAccordion>
            <Grid container spacing={2}>
              <Grid item xs>
                <Chip
                  label="DADOS GERAIS"
                  bgcolor="primary"
                  textcolor="white"
                />
              </Grid>
            </Grid>
          </HeaderAccordion>
        }
        bgcolor="white"
        textcolor="black"
        accordion
        defaultExpanded
      >
        <Line container spacing={2}>
          <Grid item xs>
            <TextField
              label="Descrição *"
              size="small"
              value={description}
              setValue={setDescription}
              error={errors.description ? true : false}
              helperText={errors.description || ""}
            />
          </Grid>
          <Grid item xs={2}>
            <TextField
              label="Valor *"
              size="small"
              mask="decimal"
              decimals={configuration?.contract_decimal_size || 2}
              value={value}
              setValue={setValue}
              error={errors.value ? true : false}
              helperText={errors.value || ""}
            />
          </Grid>
          <Grid item xs={3}>
            <SelectErp
              variant="filled"
              descriptionField="label"
              label="Tipo Serviço"
              optionsList={listServiceType}
              value={serviceType}
              setValue={setServiceType}
            />
          </Grid>
        </Line>
        <Line container spacing={2}>
            <Grid item xs={3}>
              <SelectErp
                loading={false}
                label="Perfil tributário"
                value={perfilTributario}
                onChange={handlePerfilTributarioChange}
                setValue={setPerfilTributario}
                optionsList={perfilTributarioOptions}
                error={!!errors.perfilTributario}
                helperText={errors.perfilTributario || ""}
                getOptionLabel={(option) =>
                  option ? `${option.descricao}` : ""
                }
              />
            </Grid>
          <Grid item xs={3}>
            <FormControlLabel
              label="Ativo"
              value="end"
              control={
                <Switch
                  checked={active}
                  onChange={() => {
                    setActive((current) => !current);
                  }}
                  color="primary"
                  onClick={(event) => event.stopPropagation()}
                  onFocus={(event) => event.stopPropagation()}
                />
              }
            />
          </Grid>
        </Line>
        <Line />
        {companies.length > 1 && (
          <Card line="left" padding="10" fullWidth>
            <Grid container>
              <Chip title label="Empresas" bgcolor="secondary" />
            </Grid>
            <Grid container>
              <Form>
                {companies.map((company) => (
                  <CheckItem
                    key={company.id}
                    control={
                      <Checkbox
                        checked={company.check}
                        onChange={() => {
                          handleCheckCompany(company.id);
                        }}
                      />
                    }
                    label={company.apelido}
                  />
                ))}
              </Form>
            </Grid>
          </Card>
        )}
      </Fieldset>

      <Line />
    </>
  );
};

export default AccordionClassifPrincipal;
